import { render, staticRenderFns } from "./DisplayLivestream.vue?vue&type=template&id=0a2aa3a6&scoped=true&"
import script from "./DisplayLivestream.vue?vue&type=script&lang=js&"
export * from "./DisplayLivestream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2aa3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2aa3a6')) {
      api.createRecord('0a2aa3a6', component.options)
    } else {
      api.reload('0a2aa3a6', component.options)
    }
    module.hot.accept("./DisplayLivestream.vue?vue&type=template&id=0a2aa3a6&scoped=true&", function () {
      api.rerender('0a2aa3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Livestream/DisplayLivestream.vue"
export default component.exports